export default {
    type: 'set',
    format: {},
    default: {
        logic: 'match',
        tolerance: 2,
        operand: '>=',
        value: []
    },
    setting: {
        logic: ['match', 'min', 'max']
    },
    set: {
        none: 'None',
        little: 'A little',
        moderate: 'Moderate',
        alot: 'A lot',
        all: 'All'
    },
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Language Independance',
        category: 'BGG',
        description: 'How independant of text is the game components.',
        summarise: {
            prefix: 'Language independance'
        }
    }
}